import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { Inspection, InspectionLog, ModelID } from '@/types';
import { get } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { featureKeys, featurePath, InspectionLogSearchParams } from '.';

type QueryFnType = typeof findInspectionLog;

type UseInspectionLogOptions = {
  inspection: Inspection | undefined;
  id: ModelID;
  search?: InspectionLogSearchParams;
  config?: QueryConfig<QueryFnType>;
};

const findInspectionLog = (inspection: Inspection | undefined, id: ModelID, search: any = {}) => {
  if (!inspection) {
    return new Promise<InspectionLog>((resolve, reject) => {
      resolve({} as InspectionLog);
    });
  }

  return get<InspectionLog>(`${featurePath(inspection)}/${id}`, search);
};
export const useInspectionLog = ({
  inspection,
  id,
  search = {},
  config = {},
}: UseInspectionLogOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: featureKeys.detail(+id),
    queryFn: () => findInspectionLog(inspection, id, search),
  });
};
